module.exports = __webpack_public_path__ + "img/about_en.cdae5bd6.gif";